import * as types from 'modules/dealerConfiguration/actionTypes';

/**
 * @param {boolean} payload
 * @param {Object} meta
 * @return {import('modules/global/generic.types').Action<boolean>}
 */
export const setDealerConfigReady = (payload, meta = {}) => ({
  type: types.IS_CONFIG_READY,
  payload,
  meta
});
